import React from 'react';

// Multi-select of the joins available for a source entity. The chosen joins
// decide which extra fields the rest of the workflow can use.
export default function JoinsControl({ label, joins, value = [], onChange }) {
  const options = joins || [];
  const toggle = (key) =>
    onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);

  return (
    <div className="form-field">
      <span className="form-label">{label}</span>
      {options.length === 0 && <p className="form-hint">No joins available.</p>}
      <div className="join-list">
        {options.map((join) => (
          <label key={join.key} className="join-item" title={join.description || join.label}>
            <input
              type="checkbox"
              checked={value.includes(join.key)}
              onChange={() => toggle(join.key)}
            />
            <span className="join-label">{join.label || join.key}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
